import React, { Component } from 'react';
import AppSettings from '../../AppSettings';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProFeaturesButton from '../Utils/ProFeaturesButton';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../locales/i18n';
// Ressources
import { faCircleDollar, faPalette, faPenField, faUsers, faBook, faFolders, faUserHelmetSafety } from '@fortawesome/pro-solid-svg-icons'

class OrganizationSidebar extends Component {
    navRef = React.createRef();
    itemRefs = {};
    state = { indicatorStyle: null };

    render() {
        const { activeItem, activeOrganization } = this.props;
        const title = i18n.t("Upgradez votre licence pour débloquer cette fonctionnalité");
        const isUrbasense = AppSettings.isUrbasenseUrl();

        const items = [
            { name: 'general', icon: faBook, label: i18n.t("Informations") },
            { name: 'users', icon: faUsers, label: i18n.t("Utilisateurs") },
            { name: 'projects', icon: faFolders, label: i18n.t("Projets") },
            { name: 'subscription', icon: faCircleDollar, label: i18n.t("Licence") },
            ...(!isUrbasense ? [{ name: 'themes', icon: faPalette, label: i18n.t("Thèmes"), feature: 'branding', locked: !activeOrganization?.subscription?.branding }] : []),
            { name: 'customFields', icon: faPenField, label: i18n.t("Champs personnalisés"), feature: 'customFields', locked: !activeOrganization?.subscription?.customFields },
            { name: 'priceLists', icon: faUserHelmetSafety, label: i18n.t("Actions"), feature: 'costEstimation', locked: !activeOrganization?.subscription?.costEstimation }
        ];

        return (
            <nav className='org-nav' ref={this.navRef}>
                {this.state.indicatorStyle && <div className='org-nav-indicator' style={this.state.indicatorStyle} />}
                {items.map(item =>
                    <div
                        key={item.name} title={item.locked ? title : undefined}
                        ref={(el) => { this.itemRefs[item.name] = el; }}
                        className={`org-nav-item${activeItem === item.name ? ' org-nav-item--active' : ''}`}
                        role='button' tabIndex={0}
                        onClick={(e) => this.handleClick(e, item)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.handleClick(e, item); } }}
                    >
                        <FontAwesomeIcon icon={item.icon} />
                        <span>{item.label}</span>
                        {item.locked && <ProFeaturesButton feature={item.feature} style={{ marginLeft: 'auto', fontSize: '12px' }} />}
                    </div>)}
            </nav>
        );
    }

    componentDidMount = () => {
        this.scrollActiveIntoView();
        this.updateIndicator();
        window.addEventListener('resize', this.updateIndicator);
    }

    componentWillUnmount = () => window.removeEventListener('resize', this.updateIndicator);

    componentDidUpdate = (prevProps) => {
        if (prevProps.activeItem !== this.props.activeItem) {
            this.scrollActiveIntoView();
            this.updateIndicator();
        }
    }

    scrollActiveIntoView = () => this.navRef.current?.querySelector('.org-nav-item--active')?.scrollIntoView({ inline: 'center', block: 'nearest' });

    updateIndicator = () => {
        const activeEl = this.itemRefs[this.props.activeItem];
        if (!activeEl) return;
        this.setState({ indicatorStyle: { top: activeEl.offsetTop, left: activeEl.offsetLeft, width: activeEl.offsetWidth, height: activeEl.offsetHeight } });
    }

    handleClick = (event, item) => {
        if (event.target.closest('button')) return; // Évite un double déclenchement lorsqu'on clique directement sur le bouton du cadenas
        if (!item.locked) this.props.setActiveItem(item.name);
        else {
            const button = event.currentTarget.querySelector('button');
            if (button) button.click();
        }
    }
}

const mapStateToProps = (state) => {
    return {
        activeOrganization: state.activeOrganization
    };
}

export default connect(mapStateToProps)(OrganizationSidebar);
